import './Options.css';
import { ChangeEventHandler, ReactNode, KeyboardEventHandler, useState } from 'react';

type OptionsProps = {
	id?: string;
	placeholder: string;
	onChange?: ChangeEventHandler<HTMLSelectElement>;
	onBlur?: ChangeEventHandler<HTMLSelectElement>;
	value?: string;
	disabled?: boolean;
	children: ReactNode;
	onKeyDown?: KeyboardEventHandler<HTMLSelectElement>;
	nextElement?: string;
	isValid?: boolean;
	status?: 'warning' | 'error' | 'success';
	size?: 'small' | 'large';
	icon?: boolean;
};

export const Options = ({
	id,
	placeholder,
	children,
	onChange,
	value,
	disabled,
	onKeyDown,
	nextElement,
	onBlur,
	isValid,
	size = 'small',
	icon = false,
}: OptionsProps): JSX.Element => {
	const [touched, setTouched] = useState(false);
	const statusClassname = touched && typeof isValid === 'boolean' && !isValid ? 'error ' : '';
	const placeholderClassName = placeholder ? undefined : 'empty-placeholder';

	return (
		<select-input class={icon ? 'icon' : ''}>
			<select
				id={id}
				className={`${statusClassname} ${placeholderClassName} ${size}`}
				onChange={onChange}
				onSelect={onChange}
				disabled={!onChange || disabled}
				value={value}
				onKeyDown={onKeyDown}
				data-nextelement={nextElement}
				onFocus={() => {
					if (!touched) {
						setTouched(true);
					}
				}}
				onBlur={(e) => {
					if (onBlur) onBlur(e);
				}}
			>
				{children}
			</select>

			<span className={`placeholder${value ? ' small' : ''}`}>{placeholder}</span>
		</select-input>
	);
};
